// extracted by mini-css-extract-plugin
export default {"zoomModal":"N2-z"};